import CreateNewCustomerApi from "./CreateNewCustomerApi";

export default CreateNewCustomerApi;